import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Component, Input } from '@angular/core';
import { NgbActiveModal }     from '@ng-bootstrap/ng-bootstrap';

import { ApiService }        from '../api/api.service';
import { CompanyQuoteModel } from './models/company.quote';
import { MessagesService }   from '../messages/messages.service';

@Component({
  selector   : 'wor-annual-subscription',
  template: require('./company.annual-subscription.component.html')
})
export class AnnualSubscriptionComponent {
  @BlockUI('annualSubscriptionBlock') block : NgBlockUI;

  @Input() quote : CompanyQuoteModel;

  constructor (
    public  activeModal    : NgbActiveModal,
    private apiService     : ApiService,
    private messagesService: MessagesService
  ) {}

  confirm () : void {
    this.block.start();

    this.apiService.get('/company/convert_to_workshop_yearly_from_monthly')
    .then(( wasConverted : boolean ) => {
      this.activeModal.close(wasConverted);
    })
    .catch(( err ) => {
      this.messagesService.error(err);
    })
    .finally(() => {
      this.block.stop();
    });
  }
}
